import React,{ useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Asignacion  from 'src/services/asignacion';




const columns = [
  {
    id: 'total',
    label: 'Total Asignado',
    minWidth: 90,
    align: 'right', 
  },
];

const columns2 = [ 
  {
    id: 'total',
    label: 'Cupos Totales',
    minWidth: 90,
    align: 'right',
 
  },
];

const columns3 = [
  {
    id: 'total',
    label: 'Cupo Disponible',
    minWidth: 90,
    align: 'right', 
  },
];

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 640,
  },
});

export default function StickyHeadTableYo() {
  const classes = useStyles();


  //configurar hooks
  const [rows, setRows] = useState<any[]>([]);
  const [cupo, setCupo] = useState<any[]>([]);
  const [dato, setDato] = useState<any[]>([]);



  useEffect( () => {
    
  loadData();
  loadDataCupo();
  loadDataResto()

    },[]);
  
const loadData = async () => {
    const url = await Asignacion.DatellesGeneralesAsignacion()
    const response = url
    response.forEach(() => {
      return response
    });
    setRows(response[0])
}

const loadDataCupo = async () => {
  const url = await Asignacion.DatellesGeneralesAsignacion()
  const response = url
  response.forEach(() => {
    return response
  });
  setCupo(response[1])
}

  const loadDataResto = async () => {
    const url = await Asignacion.DatellesGeneralesAsignacion()
    const response = url
    response.forEach(() => {
      return response
    });
    
    setDato(response[2])
  }

 
 

  function handleChangeView(row) {
    sessionStorage.setItem('total', row['total'] )
    console.log('click')
  
  }

  
  return (


    <Paper className={classes.root}>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align='center'
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>

          </TableHead>
          <TableBody>
            
          
              
            {rows.map((row, index) => {
             const uniqueKey = index
              return (

                
                <TableRow hover role="checkbox"  tabIndex={-1} key={uniqueKey} >
                  {columns.map((column) => {
                    const value = row[column.id];
                    return (
                      <TableCell key={column.id} align='center'>
                        {column && typeof value === 'number' ? column : value}
                       
                      </TableCell>
                    );
                  })}



                </TableRow>
              );
            })}
           
          </TableBody>

{/*  */}
{/*  */}
{/*  */}


<TableHead>
            <TableRow>
              {columns2.map((column) => (
                <TableCell
                  key={column.id}
                  align='center'
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>

          </TableHead>
          <TableBody>
            
            {cupo.map((row) => {
             
              return (
                <TableRow hover role="checkbox"  tabIndex={-1}  key={row}>
                  {columns2.map((column) => {
                    const value = row[column.id];
                    return (
                      <TableCell key={column.id} align='center'>
                        {column && typeof value === 'number' ? column : value}
                      </TableCell>
                    );
                  })}



                </TableRow>
              );
            })}
           
          </TableBody>

{/*  */}
{/*  */}
{/*  */}


<TableHead>
            <TableRow>
              {columns3.map((column) => (
                <TableCell
                  key={column.id}
                  align='center'
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>

          </TableHead>
          <TableBody>
          
            {dato.map((row, index) => {
              const uniqueKey = index
              return (
                <TableRow hover role="checkbox" onChange= {()=>{ return  handleChangeView(row);}}  tabIndex={-1} key={uniqueKey}>
                  {columns3.map((column) => {
                    const value = row[column.id];
                    return (
                      <TableCell key={column.id} align='center'>
                        {column && typeof value === 'number' ? column : value}
                      </TableCell>
                    );
                  })}



                </TableRow>
              );
            })}
           
          </TableBody>


        </Table>
      </TableContainer>
    </Paper>
  );
}

